import http from "@/apps/shared/baseService/config";

const base = {
  rota: "report",
  nome: "Avaliação"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data),
  excluir_muitos: data => http.post(`/admin/${base.rota}/delete-many`, data)
};

const module = {
  actions: {
    listar_reports: ({ commit, dispatch, getters }) => {
      if (localStorage.getItem("reports")) {
        commit("set_reports", JSON.parse(localStorage.getItem("reports")));
      } else {
        dispatch("enableLoading");
      }
      service
        .listar(getters.get_reports_filtros)
        .then(res => {
          dispatch("disableLoading");
          localStorage.setItem("reports", JSON.stringify(res.data));
          commit("set_reports", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_report: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .atualizar({ ...getters.get_report, imagens: getters.getLinks })
        .then(res => {
          dispatch("disableLoading");
          commit("set_report", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização Concluída!",
            timeout: 6000
          });
          dispatch("listar_reports");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_report: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .criar({ ...getters.get_report, imagens: getters.getLinks })
        .then(() => {
          dispatch("disableLoading");
          commit("set_report", {});
          commit("setLinks", []);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Registro Concluído!",
            timeout: 6000
          });
          dispatch("listar_reports");
          commit("set_modal_view_report", false);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_report: ({ dispatch }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão Concluída!",
            timeout: 6000
          });
          dispatch("listar_reports");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    abre_modal_view_report: ({ commit }, payload) => {
      if (payload) {
        commit("set_report", payload);
        commit("setLinks", payload.imagens);
      }
      commit("set_modal_view_report", true);
    },
    fecha_modal_view_report: ({ commit }) => {
      commit("set_report", {});
      commit("setLinks", []);
      commit("set_modal_view_report", false);
    }
  },
  state: {
    report: {},
    reports: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    reports_filtros: {
      limitPerPage: 10,
      page: 1,
      dataInicio: "",
      dataFim: ""
    },
    modal_view_report: false
  },
  mutations: {
    set_report: (state, payload) => (state.report = payload),
    set_reports: (state, payload) => (state.reports = payload),
    set_modal_view_report: (state, payload) =>
      (state.modal_view_report = payload)
  },
  getters: {
    get_report: state => state.report,
    get_reports: state => state.reports,
    get_modal_view_report: state => state.modal_view_report,
    get_reports_filtros: state => state.reports_filtros
  }
};

const routes = [
  {
    path: `/relatorio`,
    component: () => import("./views/Main.vue"),
    name: base.nome
  }
];

export default {
  service,
  module,
  routes
};
